// src/components/questions/ratingQuestion/RatingQuestion.jsx
import React from "react";
import "./ratingQuestion.css";

/**
 * RatingQuestion es un componente controlado.
 * - `value` es un string con el número seleccionado.
 * - `updateProgress` notifica el nuevo rating como string.
 */
const RatingQuestion = ({
  question,
  maxRating,
  required,
  updateProgress,
  startsInCero = false,
  value = ""
}) => {
  const offset = startsInCero ? 0 : 1;
  const selectedRating = value !== "" ? parseInt(value, 10) : null;

  const handleClick = rating => {
    updateProgress(rating.toString());
  };
  return (
    <div className="rating-question">
      <label className="question-label">
        {question} {required && <span className="required">*</span>}
      </label>
      <div className="rating-container">
        {Array.from({ length: maxRating }, (_, index) => {
          const ratingValue = index + offset;
          return (
            <div
              key={ratingValue}
              className={`rating-circle ${selectedRating === ratingValue ? "selected" : ""}`}
              onClick={() => handleClick(ratingValue)}
            >
              {ratingValue}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RatingQuestion;